/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface FilterGroup
 */
export interface FilterGroup {}

/**
 * Check if a given object implements the FilterGroup interface.
 */
export function instanceOfFilterGroup(value: object): value is FilterGroup {
  return true;
}

export function FilterGroupFromJSON(json: any): FilterGroup {
  return FilterGroupFromJSONTyped(json, false);
}

export function FilterGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FilterGroup {
  return json;
}

export function FilterGroupToJSON(value?: FilterGroup | null): any {
  return value;
}
